import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kite-flying-festival',
  templateUrl: './kite-flying-festival.component.html',
  styleUrls: ['./kite-flying-festival.component.scss']
})
export class KiteFlyingFestivalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
